import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { SITE } from "@/lib/site";
import { OPEN_COOKIE_PREFS_EVENT } from "@/components/CookieBanner";

const LegalLinks = () => (
  <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-4 text-xs" aria-label="Link legali">
    <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-gray-400 hover:text-amber-500 transition-colors">
      Privacy Policy
    </Link>
    <Link to="/cookie-policy" data-testid="footer-cookie-link" className="text-gray-400 hover:text-amber-500 transition-colors">
      Cookie Policy
    </Link>
    <button
      data-testid="footer-cookie-prefs-btn"
      onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_PREFS_EVENT))}
      className="text-gray-400 hover:text-amber-500 transition-colors"
    >
      Gestisci cookie
    </button>
  </nav>
);

export const Footer = () => (
  <footer className="border-t border-border bg-[#0A0D14]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 flex flex-col md:flex-row md:items-center justify-between gap-8">
      <div>
        <img src="/logo.png" alt="Manno Auto S.r.l." className="h-11 w-auto" data-testid="footer-logo" />
        <p className="mt-3 text-sm text-gray-500 max-w-sm">
          {SITE.name} — Concessionaria plurimarca. {SITE.address}
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-6 sm:items-center text-sm text-gray-500">
        <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="hover:text-amber-500 transition-colors" data-testid="footer-phone">
          {SITE.phone}
        </a>
        <a href={`mailto:${SITE.email}`} className="hover:text-amber-500 transition-colors" data-testid="footer-email">
          {SITE.email}
        </a>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="inline-flex items-center gap-1.5 hover:text-amber-500 transition-colors"
        >
          <Lock className="w-3.5 h-3.5" /> Area Riservata
        </Link>
      </div>
    </div>
    <div className="border-t border-border py-6 px-4 text-center">
      <LegalLinks />
      <p className="text-[11px] text-gray-500 tracking-wide leading-relaxed" data-testid="footer-legal">
        MANNO AUTO s.r.l. - Sede Legale: Contrada Lavanghe dell'Oglio s.n.c., 92011 Cattolica Eraclea (AG) - P.IVA / C.F.: 02486060847
      </p>
      <p className="mt-2 text-[10px] text-gray-600 font-mono2 uppercase tracking-widest">
        © {new Date().getFullYear()} {SITE.name} · Tutti i diritti riservati
      </p>
    </div>
  </footer>
);

export const LegalStrip = () => (
  <div className="border-t border-border py-6 px-4 text-center" data-testid="legal-strip">
    <LegalLinks />
    <p className="text-[11px] text-gray-500 tracking-wide leading-relaxed">
      MANNO AUTO s.r.l. - Sede Legale: Contrada Lavanghe dell'Oglio s.n.c., 92011 Cattolica Eraclea (AG) - P.IVA / C.F.: 02486060847
    </p>
    <p className="mt-2 text-[10px] text-gray-600 font-mono2 uppercase tracking-widest">
      © {new Date().getFullYear()} {SITE.name} · Tutti i diritti riservati
    </p>
  </div>
);
